import React, {Component} from 'react'
import InlineSVG from "react-inlinesvg";
import FJLocalStore from '../../../store/FJLocalStore';
import Style from "./FJMenu.module.less";
import FJLogoContainer from "../container/FJLogoContainer";
import mediaIcon from "../../../icon/mediaIcon.svg";
import textIcon from "../../../icon/textIcon.svg";
import backgroundIcon from "../../../icon/backgroundIcon.svg";
import overlayIcon from "../../../icon/overlay.svg";
import elementIcon from "../../../icon/element.svg";
import FJSelectedBackground from "./FJSelectedBackground";
import FJToolButton from "./FJToolButton";
import FJViewConstant from "../../../constant/FJViewConstant";
import transitionIcon from '../../../icon/transition.svg';
import watermarkIcon from '../../../icon/watermark.svg';
import moreIcon from '../../../icon/more.svg';

class FJMenu extends Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();
    this._titles = [
      {
        icon: <InlineSVG src={mediaIcon}/>,
        span: "media",
        type: FJViewConstant.RESOURCES_MEDIA,
      },
      {
        icon: <InlineSVG src={textIcon}/>,
        span: "text",
        type: FJViewConstant.RESOURCES_TEXT,
      },
      {
        icon: <InlineSVG src={overlayIcon}/>,
        span: "overlays",
        type: FJViewConstant.RESOURCES_OVERLAY,
      },
      {
        icon: <InlineSVG src={elementIcon}/>,
        span: "elements",
        type: FJViewConstant.RESOURCES_ELEMENT,
      },
      {
        icon: <InlineSVG src={backgroundIcon}/>,
        span: "background",
        type: FJViewConstant.RESOURCES_BACKGROUND,
      },
			{
				icon: <InlineSVG src={transitionIcon} />,
				span: 'transition',
				type: FJViewConstant.RESOURCES_TRANSITION
			},
			{
				icon: <InlineSVG src={watermarkIcon} />,
				span: 'watermark',
				type: FJViewConstant.RESOURCES_WATER_MARK
			},
      {
        icon: <InlineSVG src={moreIcon} />,
        span: 'more',
        type: FJViewConstant.RESOURCES_MORE
      }
    ];
    this._itemHeight = 60;
  }

  _calcIndexWithType = (type) => {
    return this._titles.findIndex(item => item.type === type);
  };

  _getDirection = (type) => {
    let __index = this._calcIndexWithType(type);
    let __preIndex = this._calcIndexWithType(this.props.activePanelType);
    return __index > __preIndex ? 1 : 0;
  };

  _getItems = () => {
    return this._titles.map((item, index) => {
      let {activePanelType, changeType, isResourceExpand} = this.props;
      let {type, icon, span} = item;
      return (
        <FJToolButton key={type}
                      active={isResourceExpand && activePanelType === item.type}
                      onClick={() => {
                        changeType(type, this._getDirection(type));
                      }}
                      icon={icon}
                      text={FJLocalStore._(span)}/>
      );
    });
  };

  /**
   * @description 计算占位符的偏移值
   * @return {number}
   * @private
   */
  _calcSelectedBackgroundTop = () => {
    const {activePanelType, isResourceExpand} = this.props;
    let __index = this._calcIndexWithType(activePanelType);
    __index = isResourceExpand ? __index : -1;
    if (__index === -1) {
      return __index;
    } else {
      return __index * this._itemHeight;
    }
  };

  render() {
    let __top = this._calcSelectedBackgroundTop();
    return (
      <div ref={this.container} className={Style.menu_box}>
        <FJLogoContainer />
        {__top === -1 ? null : <FJSelectedBackground top={__top + 101} />}
        {this._getItems()}
      </div>
    );
  }
}

export default FJMenu;
